/**
 * @name buildUrl
 * @description Returns a URL for the given route name.
 */
export function buildUrl(path: string) {
  const isBrowser = typeof window !== 'undefined';
  const url = isBrowser ? `${window.location.origin}${path}` : '';

  return url;
}
